module.exports = __webpack_public_path__ + "img/icon_check_mid.1d0f5fff.svg";